const initialState = {
	errors: null,
	gymSaving: false,
	gymsList: null,
};

export default initialState;
